import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Play } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex items-center pt-20 overflow-hidden" data-id="element-75">
      {/* Background Elements */}
      <div className="absolute inset-0 z-0" data-id="element-76">
        <div className="absolute top-[-10%] right-[-10%] w-[500px] h-[500px] bg-brand-accent/5 rounded-full blur-[120px]" data-id="element-77" />
        <div className="absolute bottom-[-10%] left-[-10%] w-[400px] h-[400px] bg-blue-500/5 rounded-full blur-[100px]" data-id="element-78" />
        <div className="absolute inset-0 opacity-20 bg-[url('https://images.unsplash.com/photo-1557804506-669a67965ba0?auto=format&fit=crop&q=80')] bg-cover bg-center mix-blend-overlay" data-id="element-79" />
      </div>

      <div className="container mx-auto px-6 relative z-10" data-id="element-80">
        <div className="max-w-4xl" data-id="element-81">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} data-id="element-82">
            <span className="inline-block py-1 px-3 rounded-full bg-brand-accent/10 border border-brand-accent/20 text-brand-accent text-xs font-bold tracking-widest uppercase mb-6" data-id="element-83">
              Next-Gen Operational Partner
            </span>
            <h1 className="text-5xl md:text-7xl font-serif font-bold text-white leading-[1.1] mb-8" data-id="element-84">
              Scale Your Operations <br data-id="element-85" />
              <span className="text-brand-accent" data-id="element-86">
                Without Scaling Your Team
              </span>
            </h1>
            <p className="text-xl text-slate-400 leading-relaxed max-w-2xl mb-10" data-id="element-87">
              Deskmayte acts as your operational extension — managing customer
              acquisition, staffing, lead generation, outreach, and marketing
              while your team focuses on growth.
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-4" data-id="element-88">
              <button className="w-full sm:w-auto bg-brand-accent text-brand-dark px-8 py-4 rounded-xl font-bold text-lg flex items-center justify-center gap-2 hover:bg-white transition-all group" data-id="element-89">
                Book Discovery Call
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-90" />
              </button>
              <button className="w-full sm:w-auto bg-white/5 border border-white/10 px-8 py-4 rounded-xl font-bold text-lg flex items-center justify-center gap-2 hover:bg-white/10 transition-all" data-id="element-91">
                <Play className="w-5 h-5 fill-current" data-id="element-92" />
                Explore Services
              </button>
            </div>
          </motion.div>

          {/* Trust Badges */}
          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.5,
          duration: 1
        }} className="mt-20 pt-10 border-t border-white/5 flex flex-wrap items-center gap-12 opacity-50 grayscale hover:grayscale-0 transition-all" data-id="element-93">
            <span className="text-sm font-semibold uppercase tracking-widest" data-id="element-94">
              Trusted by industry leaders
            </span>
            <div className="flex flex-wrap gap-8 items-center" data-id="element-95">
              <div className="text-xl font-bold" data-id="element-96">FORBES</div>
              <div className="text-xl font-bold" data-id="element-97">TECHCRUNCH</div>
              <div className="text-xl font-bold" data-id="element-98">BLOOMBERG</div>
              <div className="text-xl font-bold" data-id="element-99">WIRED</div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}